import { paths } from './settings'
import { GlobalState } from './globalState'

export interface AssetEntry {
  name: string
  srcs: string
}

interface BgImageInfo {
  id: string
}

interface LayerData {
  background?: BgImageInfo[]
  foreground?: BgImageInfo[]
  extra?: {
    skryta_mista?: Array<{ id: string }>
  }
}

function getImageBundle(): AssetEntry[] {
  return GlobalState.positionsConfig.flatMap(({ background = [], foreground = [], extra }: LayerData) => {
    const images: AssetEntry[] = []

    // Normal layer images
    images.push(
      ...[...background, ...foreground].map(({ id }) => ({
        name: id,
        srcs: `${paths.IMAGES_PATH}main/layers/${id}.png`,
      })),
    )

    // Hidden places (skryta_mista)
    const hiddenPlaces = extra?.skryta_mista ?? []
    for (const place of hiddenPlaces) {
      images.push({
        name: `sm_${place.id}`,
        srcs: `${paths.IMAGES_PATH}page/sm_${place.id}.jpg`,
      })
    }

    return images
  })
}

// TODO: Future?
// function getItemSoundsBundle(): AssetEntry[] {
//   return Object.entries(itemsConfig).flatMap(([key, { numSounds }]) =>
//     Array.from({ length: Math.max(numSounds - 1, 0) }, (_, i) => ({
//       name: `${key}_${i + 1}`,
//       srcs: `${paths.AUDIO_ITEMS_PATH}${key}_${i + 1}.ogg`,
//     })),
//   )
// }

const DATA_BUNDLE: AssetEntry[] = [{ name: 'rawActivities', srcs: `${paths.DATA_PATH}activities.json` }]
const SPRITESHEET_BUNDLE: AssetEntry[] = [
  { name: 'items', srcs: `${paths.SPRITES_PATH}items.json` },
  { name: 'extra', srcs: `${paths.SPRITES_PATH}extra.json` },
]

export const bundles = {
  data: DATA_BUNDLE,
  spriteSheets: SPRITESHEET_BUNDLE,
  images: getImageBundle(),
  // TODO: Future?
  // sounds: getItemSoundsBundle()
}
